import { CreateOperatorRequest } from '../../types'

export const CREATE_OPERATOR_ERROR_FIELD_MAPPERS: Record<
	string,
	keyof CreateOperatorRequest
> = {
	DUPLICATE_USERNAME: 'username',
}
